<template>
  <div>
    <div class="row d-flex flex-column align-items-center justify-content-center px-md-5 px-1" v-if="isTimeNotExceed">
      <div class="s-14 mb-2 d-flex justify-content-center" style="text-align: center">
        <p>
          <strong>({{ SendCodeRequestServiceI.selected.phone }})</strong>
          We sent a verification code to the phone and confirm the code
        </p>
      </div>
      <div class="mt-2 mb-3">
        <input type="number"
               class="code-box"
               min="0"
               max="9"
               :ref="key"
               oninput="this.value = (Math.round(this.value) || this.value === '0') && (this.value.length <= 1 || this.value.length === 5) ? this.value : '';"
               @input="changeFocus(key)"
               v-model="code[key]"
               pattern="[0-9]*"
               @keyup.enter="key === 'provider5' ? confirm() : ''"
               :key="key"
               v-for="(provider, key) in code">
      </div>
      <div class="s-14 f-bold d-flex flex-row">
        <div class="c-989898">
          Remaining time<span class="ml-1">{{counterTime}}</span>s.
        </div>
        <span class="c-2c8fe3 ml-1 mouse-click" @click="$emit('resend')">
        <u>Resend code</u>
      </span>
      </div>
      <div class="btn ls-btn-secondary s-12 px-4 mt-4" style="width: 120px" @click="confirm">
        Confirm
      </div>
    </div>
    <div class="row d-flex flex-column justify-content-center align-items-center" v-else>
      <span style="font-size: 45px" class="c-ed0080">
        <i class="far fa-history"/>
      </span>
      <span class="f-bold s-16">
        Your time has expired
      </span>
      <div class="btn ls-btn-secondary s-12 px-4 mt-4"
           @click="$emit('resend')"
           style="width: 150px">
        Resend the code
      </div>
    </div>
  </div>
</template>

<script>
import ActivityService from '@/modules/common/services/activity.service';
import ValidateLandingServices from '../services/validateLanding.services';

export default {
  data() {
    return {
      code: {
        provider1: '',
        provider2: '',
        provider3: '',
        provider4: '',
        provider5: '',
      },
      counterTime: 180,
    };
  },
  props: {
    SendCodeRequestServiceI: {
      required: true,
    },
  },
  created() {
    this.countdown();
  },
  mounted() {
    if (Object.prototype.hasOwnProperty.call(this.$refs, 'provider1')) {
      this.$refs.provider1[0].focus();
    }
  },
  computed: {
    isTimeNotExceed() {
      return (this.counterTime > 0);
    },
  },
  methods: {
    async confirm() {
      try {
        let code = '';
        Object.keys(this.code).forEach((key) => {
          code += this.code[key];
        });

        if (code.length === 5) {
          const { result: { data } } = await new ValidateLandingServices().verifySmsCode(this.$route.params.document_unique_key, { code });
          await this.$store.dispatch('setToken', data);
          // successfully entered
          setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 169), 0);
          await this.$router.push({
            name: 'Contract',
          });
        } else {
          // incorrect code entering
          setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 170), 0);
          this.errorMessage('Verification code must contain five digits.');
        }
      } catch (e) {
        // incorrect code entering
        setTimeout(() => new ActivityService().record(this.$route.params.document_unique_key, 170), 0);
        this.errorMessage('You have entered the wrong  verification code');
      }
    },

    /**
     * gets last mutated input's key, check its value and if it is fulfilled then focus next one
     * @param key {string}
     */
    changeFocus(key) {
      if (this.code[key] && this.code[key].length === 5) {
        const code = this.code[key];
        for (let i = 0; i < code.length; i += 1) {
          this.code[`provider${i + 1}`] = +code[i];
        }

        this.$refs.provider5[0].focus();
        this.confirm();
      } else if (this.code[key] !== '') {
        // current focused input
        const baseKey = parseFloat(key.slice(key.length - 1));

        // prevent focusing next element when focus in the last input
        if (baseKey !== Object.keys(this.code).length) {
          this.$refs[`provider${baseKey + 1}`][0].focus();
        }
      }
    },
    countdown() {
      if (this.counterTime > 0) {
        const VALIDITY_DURATION = 180; // seconds

        const endDate = new Date(new Date().getTime() + (VALIDITY_DURATION * 1000));

        setInterval(() => {
          const current = new Date();
          const difference = endDate.getTime() - current.getTime();

          this.counterTime = Math.round((difference) / 1000);
        }, 10);
      }
    },
  },
};
</script>

<style scoped>
.code-box {
  width: 45px;
  height: 45px;
  margin-right: 15px;
  font-size: 25px;
  text-align: center;
}

input.code-box::-webkit-outer-spin-button,
input.code-box::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input.code-box[type=number] {
  -moz-appearance: textfield;
}

</style>
